import React, { useState, ChangeEvent } from 'react';
import { TextField } from '@cimpress/react-components';

export type UpdateCustomTickFn = (data: { id: string; index: number; value: number }) => void;
export type RemoveCustomTickFn = (data: { id: string; index: number }) => void;

interface CustomTickProps {
    segments: number;
    value: number;
    id: string;
    index: number;
    updateCustomTick: UpdateCustomTickFn;
    removeCustomTick: RemoveCustomTickFn;
}

const isError = (value: number, segments: number) =>
    !(Number.isFinite(value) && value >= 0 && value <= segments) ? 'error' : undefined;

const CustomTick: React.FC<CustomTickProps> = ({ segments, value, id, index, updateCustomTick, removeCustomTick }) => {
    const [validValue, setValidValue] = useState(value);
    const [currentValue, setCurrentValue] = useState(value);

    if (value !== validValue) {
        setValidValue(value);
        setCurrentValue(value);
    }

    const status = isError(currentValue, segments);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = parseFloat(e.target.value);
        const error = isError(newValue, segments);
        setCurrentValue(newValue);
        if (!error) {
            updateCustomTick({ id, index, value: newValue });
        }
    };

    const onDelete = () => {
        removeCustomTick({ id, index });
    };

    return (
        <div className='custom-tick'>
            <TextField
                className='custom-tick__field'
                label='Tick'
                value={currentValue || (currentValue === 0 ? 0 : '')}
                onChange={onChange}
                status={status}
                type='number'
                onFocus={(e) => e.target.select()}
            />
            <div className='custom-tick__delete' onClick={onDelete}>
                <img className='icon2x colorOceanBase' src='https://static.ux.cimpress.io/assets/icons/bin-1-f.svg' />
            </div>
        </div>
    );
};

export default React.memo(CustomTick);
